const NumPad = require('./NumPad');

/**
 * Creates instances of NumPad. This factory is useful because NumPad
 * has some dependencies. This factory class supplies the dependencies so whoever wants an instance
 * doesn't have to.
 *
 * @constructor
 *
 * @param $timeout
 * @param {UserService} userService
 */
const NumPadFactory = function (
    $timeout,
    userService
) {
    this.$timeout = $timeout;
    this.userService = userService;
};

NumPadFactory.prototype = {
    /**
     * @param {object} options
     *
     * @return {NumPad}
     */
    create: function create(
        options
    ) {
        return new NumPad(
            this.$timeout,
            this.userService.currentUser.company.currency.currencyDenominations,
            options
        );
    },
};

module.exports = NumPadFactory;
